import {
  Button,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  Typography,
} from '@material-ui/core'
import Grow from '@material-ui/core/Grow'
import { makeStyles } from '@material-ui/core/styles'
import ConfirmationDialog from 'app/components/ConfirmationDialog'
import { ButtonWithLoading } from 'app/components/FormsyHelperComponent'
import GridAllItem from 'app/components/layout/GridAllItem'
import { NOTI_PRIORITY_LOW } from 'app/constants/priority'
import { useFormsy } from 'commons/form'
import Formsy from 'formsy-react'
import * as R from 'ramda'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { OVERRIDE_TRANSLATION } from '../../notification/CreateNotiLens'
import FormsyTranslationPreview from '../../notification/FormsyTranslationPreview'
import { useNotiToPreviewMapper } from '../../notification/PreviewMapper'
import NotiTips from '../../notification/selectType/NotiTips'
import useUpdateInitialNotification from './useUpdateInitialNotification'

import { TextInput } from 'app/components/FormsyHelperComponent'
import MessageAlert from 'app/components/MessageAlert'
import CancelButton from 'app/components/buttons/CancelButton'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import { RevertIcon } from 'app/components/icons'
import NotificationDescriptionStatus from 'app/components/richTextEditor/NotificationDescriptionStatus'
import RichTextEditorFormsy, {
  richTextLengthValiator,
} from 'app/components/richTextEditor/RichTextEditorFormsy'
import useFeatureFlag from 'app/configs/useFeatureFlag'
import { DESCRIPTION_MAX_LENGTH, TITLE_MAX_LENGTH } from 'app/constants/compose'
import { TYPE_GENERAL } from 'app/constants/messageType'
import effects from 'app/effects/effects'
import { denormalizeEmptyParagraphs } from 'app/main/composeMessage/tiptapEditor/TiptapUtils'
import VoucherAttachSelector from 'app/main/dealsPromotions/VoucherAttachSelector'
import useVoucherAttachment from 'app/main/dealsPromotions/useVoucherAttachment'
import { htmlToPlainText } from 'libs/text'
import { useDispatch } from 'react-redux'
import TiptapFormsy, { tiptapLengthValiator } from './TiptapFormsy'
import TiptapTitleFormsy from './TiptapTitleFormsy'

const useStyles = makeStyles((theme) => ({
  title: {
    paddingBottom: 0,
  },
  DividerStyle: {
    width: '90%',
    margin: '0 auto',
  },
  classClose: {
    textAlign: 'center',
    fontSize: '20px',
    cursor: 'pointer',
  },
  iconSize: {
    fontSize: '22px',
    color: '#000000',
    fontWeight: 'bold',
  },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow ref={ref} {...props} />
})
const EditInitialNotificationDialog = (props) => {
  const { notification, defaultLanguage, openState, onClose, onUpdateSuccess } =
    props

  const {
    mes_4297_tiptap_editor,
    mes_2832_new_template_initial_message,
    mes_4885_initial_msg_title,
  } = useFeatureFlag()

  const dispatch = useDispatch()
  const isOpen = openState.isOpen
  const classes = useStyles()
  const handlerOnCreateSuccess = useCallback(
    (successModel) => {
      onUpdateSuccess(successModel)
      onClose()
    },
    [onClose, onUpdateSuccess],
  )
  const { submitNoti, isSubmitting } = useUpdateInitialNotification(
    handlerOnCreateSuccess,
  )
  const { isLoading, vouchers } = useVoucherAttachment({ isOpen })

  const [isFormValid, setIsFormValid] = useState(false)
  const formRef = useRef()
  const { isPristine, onChange } = useFormsy(formRef)
  const getFormModel = () =>
    !R.isNil(formRef.current) ? formRef.current.getModel() : {}

  const callSubmit = () => {
    if (!R.isNil(formRef.current)) formRef.current.submit()
  }

  const disableButton = () => setIsFormValid(false)
  const enableButton = () => setIsFormValid(true)

  // validation
  const { formatMessage } = useIntl()

  const [isShowConfirmDialog, setIsShowConfirmDialog] = useState(false)

  //Preview
  const [isOpenPreview, setIsOpenPreview] = useState(false)
  const openPreview = () => setIsOpenPreview(true)
  const closePreviewThenSubmit = () => {
    setIsOpenPreview(false)
    callSubmit()
  }
  const closePreview = () => setIsOpenPreview(false)
  const mapper = useNotiToPreviewMapper()
  const previewNotification = mapper(getFormModel())
  const addMissingRequiredProps = R.compose(
    R.set(R.lensProp('priority'), NOTI_PRIORITY_LOW.label),
    R.set(R.lensProp('type'), TYPE_GENERAL),
  )
  const [uploadingCount, setUploadingCount] = useState(0)
  const incUploadingCount = useCallback(() => {
    setUploadingCount(R.inc)
  }, [setUploadingCount])
  const decUploadingCount = useCallback(() => {
    setUploadingCount(R.when(R.gt(R.__, 0), R.dec))
  }, [setUploadingCount])
  const isUploadingFiles = uploadingCount !== 0

  const closeDialog = () => {
    setIsShowConfirmDialog(false)
    onClose(false)
  }
  const closingDialog = () => {
    if (isPristine) {
      closeDialog()
    } else {
      setIsShowConfirmDialog(true)
    }
  }
  const cancelClosingDialogWarning = () => {
    setIsShowConfirmDialog(false)
  }

  const isFormDisabled = () => {
    return !isFormValid || isSubmitting || isPristine || isUploadingFiles
  }
  // When has default language notification inside translations will show default language
  // When no default language notification inside translations will show first items
  const defaultLanguageInitialNotification = R.compose(
    R.ifElse(
      R.propEq('languageId', defaultLanguage.id),
      R.find(R.propEq('languageId', defaultLanguage.id)),
      R.head,
    ),
    R.prop('translations'),
  )(notification)

  const handleWindowClose = useCallback((e) => {
    var dialogText = formatMessage({
      //message can't be custom in some browser and some version.
      id: 'createNotification.dialog.confirmClose.dialog.title',
    })
    e.returnValue = dialogText
    return dialogText
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClickBack = useCallback((e) => {
    if (
      window.confirm(
        formatMessage({
          id: 'createNotification.dialog.confirmClose.alert.title',
        }),
      )
    ) {
      window.history.back()
      window.removeEventListener('popstate', handleClickBack)
    } else {
      window.history.pushState(null, null, null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClickDefaultTemplate = useCallback(() => {
    effects.apis
      .getDefaultInitailTemplate()
      .then((info) => {
        let model = formRef.current.getModel()
        formRef.current.reset({
          ...model,
          title: info.title,
          body: info.description,
        })
      })
      .catch((error) => {
        dispatch(MessageAlert.showNetworkError(formatMessage)(error))
      })
  }, [])

  useEffect(() => {
    if (!isPristine & isOpen) {
      window.addEventListener('beforeunload', handleWindowClose)
      return function cleanup() {
        window.removeEventListener('beforeunload', handleWindowClose)
        window.removeEventListener('popstate', handleClickBack)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPristine, isOpen])

  useEffect(() => {
    window.addEventListener('popstate', handleClickBack)
    window.history.pushState(null, null, null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const scrollableContainerId = 'scrollable-container'
  const scrollableContainerSelector = `#${scrollableContainerId}`

  return (
    <ResponsiveDialog
      open={isOpen && !isLoading}
      maxWidth="md"
      TransitionComponent={Transition}
    >
      <DialogTitle id="scroll-dialog-title" className={classes.title}>
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <FormattedMessage id="editInitialNotification.dialog.title" />
          </Grid>
          <Grid
            item
            xs={1}
            className={classes.classClose}
            onClick={closingDialog}
          >
            <Icon className={classes.iconSize} color="action">
              close
            </Icon>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent id={scrollableContainerId} style={{ paddingTop: 0 }}>
        <div className="flex flex-col md:flex-row md:justify-between pb-16 md:items-center">
          <div className="flex flex-col pb-8 md:pb-0">
            <Typography>
              <FormattedMessage id="editInitialNotification.dialog.subtitle" />
            </Typography>
          </div>
          <div>
            <NotiTips />
          </div>
        </div>
        <Formsy
          onChange={onChange}
          onValidSubmit={submitNoti}
          onValid={enableButton}
          onInvalid={disableButton}
          ref={formRef}
        >
          <GridAllItem spacing={2}>
            {mes_4885_initial_msg_title ? (
              <TiptapTitleFormsy
                name="title"
                value={R.prop('title', defaultLanguageInitialNotification)}
                required
                label={formatMessage({
                  id: 'createNotification.dialog.title.label',
                })}
                maxLength={TITLE_MAX_LENGTH}
              />
            ) : (
              <TextInput
                name="title"
                value={htmlToPlainText(
                  R.prop('title', defaultLanguageInitialNotification),
                )}
                required
                labelId="createNotification.dialog.title.label"
                placeholderId="createNotification.dialog.title.label"
                maxLength={TITLE_MAX_LENGTH}
                fullWidth
              />
            )}
          </GridAllItem>
          <GridAllItem className="py-5">
            {mes_4297_tiptap_editor ? (
              <TiptapFormsy
                name="body"
                value={denormalizeEmptyParagraphs(
                  R.prop('body', defaultLanguageInitialNotification),
                )}
                label={formatMessage({
                  id: 'createNotification.dialog.body.label',
                })}
                linkEnabled
                maxLength={DESCRIPTION_MAX_LENGTH}
                validations={{
                  textLength: tiptapLengthValiator(DESCRIPTION_MAX_LENGTH),
                }}
                textStatus={NotificationDescriptionStatus}
                isDoNotTranslateEnable={false}
                required
                onUploading={incUploadingCount}
                onUploaded={decUploadingCount}
                scrollableContainer={scrollableContainerSelector}
              />
            ) : (
              <RichTextEditorFormsy
                name="body"
                value={R.prop('body', defaultLanguageInitialNotification)}
                label={formatMessage({
                  id: 'createNotification.dialog.body.label',
                })}
                linkEnabled
                maxLength={DESCRIPTION_MAX_LENGTH}
                validations={{
                  textLength: richTextLengthValiator(DESCRIPTION_MAX_LENGTH),
                }}
                textStatus={NotificationDescriptionStatus}
                isDoNotTranslateEnable={false}
                required
                onUploading={incUploadingCount}
                onUploaded={decUploadingCount}
                scrollableContainer={scrollableContainerSelector}
              />
            )}

            <Button
              onClick={onClickDefaultTemplate}
              className="text-secondary hover:bg-white normal-case p-0 mb-4 mt-2"
            >
              <div className="flex justify-between space-x-2">
                <RevertIcon />
                <span>
                  <FormattedMessage id="initialMessage.revert.button" />
                </span>
              </div>
            </Button>
          </GridAllItem>
          <GridAllItem spacing={2}>
            <VoucherAttachSelector
              name="voucher"
              vouchers={vouchers}
              selectedVoucher={
                R.path(['voucher'], notification)
                  ? R.mergeLeft(
                      notification.voucher,
                      R.o(
                        R.head,
                        R.pathOr([], ['voucher', 'translates']),
                      )(notification),
                    )
                  : ''
              }
              disabled={formRef.current && !formRef.current.getModel().voucher}
              onClickRemove={(ev) => {
                let model = formRef.current.getModel()
                formRef.current.reset({ ...model, voucher: '' })
              }}
            />
          </GridAllItem>
          {isOpenPreview && (
            <FormsyTranslationPreview
              name={OVERRIDE_TRANSLATION}
              recipients={null} // All recipients
              language={1}
              open={isOpenPreview}
              onClose={closePreview}
              notification={addMissingRequiredProps(previewNotification)}
              onClickSendNow={closePreviewThenSubmit}
              isInitialNotification={true}
            />
          )}
        </Formsy>
        <div className="flex flex-row w-full py-10">
          <ButtonWithLoading
            className="w-1/2 ltr:mr-8 rtl:ml-8"
            isLoading={false}
            disabled={!isFormValid}
            labelId="editInitialNotification.dialog.previewButton.label"
            onClick={openPreview}
          />
          <ButtonWithLoading
            className="w-1/2 ltr:ml-8 rtl:mr-8"
            isLoading={isSubmitting || !isOpen}
            disabled={isFormDisabled()}
            onClick={callSubmit}
            labelId="editInitialNotification.dialog.saveButton.label"
          />
        </div>
      </DialogContent>
      <ConfirmationDialog
        open={isShowConfirmDialog}
        title={formatMessage({
          id: 'editInitialNotification.dialog.confirmClose.dialog.title',
        })}
        body={formatMessage({
          id: 'editInitialNotification.dialog.confirmClose.dialog.detail',
        })}
        TextFooter={formatMessage({
          id: 'editInitialNotification.dialog.confirmClose.dialog.footer',
        })}
        CancelButton={
          <CancelButton onClick={cancelClosingDialogWarning}>
            <FormattedMessage id="action.cancel" />
          </CancelButton>
        }
        ConfirmButton={
          <PrimaryButton onClick={closeDialog}>
            <FormattedMessage id="action.ok" />
          </PrimaryButton>
        }
      />
    </ResponsiveDialog>
  )
}

export default React.memo(EditInitialNotificationDialog)
